export const HIT_OKR_DASHBOARD = 'HIT_OKR_DASHBOARD';
export const GET_OKR_DASHBOARD = 'GET_OKR_DASHBOARD';

export const HIT_TEAM_DASHBOARD = 'HIT_TEAM_DASHBOARD';
export const GET_TEAM_DASHBOARD = 'GET_TEAM_DASHBOARD';

export const HIT_DEPARTMENT_DASHBOARD = 'HIT_DEPARTMENT_DASHBOARD';
export const GET_DEPARTMENT_DASHBOARD = 'GET_DEPARTMENT_DASHBOARD';
